export default __webpack_public_path__ + "static/charles-schwab-1be5eebc79876d96ab47384d93b18d69.png";